var FilterChain = /** @class */ (function () {
    function FilterChain(filters) {
        var _this = this;
        this.chain = [];
        var instancedFilters = filters.map(function (filter) { return new filter; });
        this.chain = instancedFilters.map(function (filter, index) { return function (config) {
            return filter.filter(config, _this.chain[index + 1]);
        }; });
    }
    FilterChain.prototype.execute = function (config) {
        return this.chain[0](config);
    };
    return FilterChain;
}());
export default FilterChain;
